import * as formily from '@formily/react';
import { FormComMap } from '../components';
import { FormUiMap } from '../FormUI';
import { OtherMap } from '../Other';
import { Form as F } from './Form';
export const Form = Object.assign(F, { ...FormComMap,
  ...FormUiMap,
  ...OtherMap,
  formily
});
export default Form;
export * from './extendsEffects';
//# sourceMappingURL=es/Form/index.js.map